export function generateSrcSet(url, widths) {
  if (!url) return ''
  const separator = url.includes('?') ? '&' : '?'
  return widths.map((width) => `${url}${separator}width=${width} ${width}w`).join(', ')
}

export const IMAGE_WIDTHS = [320, 480, 560, 640, 720, 960]

export function ResultImage({ result, children, sizes = '50vw', widths = IMAGE_WIDTHS }) {
  return (
    <div className="bg-brand-beige-dark relative h-full w-full overflow-hidden border-0">
      {result?.images?.length > 3 ? (
        <>
          <img
            className="absolute inset-0 h-full w-full object-cover object-bottom"
            srcSet={generateSrcSet(result.images[3].src, widths)}
            sizes={sizes}
            alt={result.images[3].alt}
          />
          <img
            className="absolute inset-0 h-full w-full object-cover object-bottom transition-all sm:group-hover/card:opacity-0"
            srcSet={generateSrcSet(result.images[0].src, widths)}
            sizes={sizes}
            alt={result.images[0]?.alt ?? ''}
          />
        </>
      ) : result.images?.length > 0 ? (
        <img
          className="absolute inset-0 h-full w-full object-cover object-bottom"
          srcSet={generateSrcSet(result.images[0]?.src ?? '', widths)}
          sizes={sizes}
          alt={result.images[0]?.alt ?? ''}
        />
      ) : result.image ? (
        <img
          className="absolute inset-0 h-full w-full object-cover object-bottom"
          srcSet={generateSrcSet(result.image, IMAGE_WIDTHS)}
          sizes="50vw"
          alt={result.name ?? ''}
        />
      ) : null}
      {children}
    </div>
  )
}
